import { Routes, Route } from "react-router-dom";

import FrontendMasterLayout from "../../layouts/frontend/MasterLayout";

import Home from "../../components/frontend/Home";
import Login from "../../components/frontend/login";
import Register from "../../components/frontend/register";

import Page403 from "../../components/errors/Page403";
import Page404 from "../../components/errors/Page404";

import Contact from "../../components/frontend/Contact";
import About from "../../components/frontend/About";

import ControlAuthRoutes from "../ControlAuthRoutes";

import ViewCategories from "../../components/frontend/collections/ViewCategories";
import ViewProducts from "../../components/frontend/collections/ViewProducts";
import ProductDetails from "../../components/frontend/collections/ProductDetails";

import Cart from "../../components/frontend/Cart";

import Checkout from "../../components/frontend/Checkout";

import Thankyou from "../../components/frontend/Thankyou";

const WebRoutes = () => {

    return (
        <Routes>
            <Route path="/" element={<FrontendMasterLayout />}>

                <Route index element={<Home />} />
                <Route path="/collections" element={<ViewCategories />} />
                <Route path="/collections/:slug" element={<ViewProducts />} />
                <Route path="/collections/:category/:product" element={<ProductDetails/>} />

                <Route path="/cart" element={<Cart />} />

                <Route path="/checkout" element={<Checkout />} />

                <Route path="/thank-you" element={<Thankyou />} />

                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/403" element={<Page403 />} />
                <Route path="/404" element={<Page404 />} />

                <Route path="/" element={<ControlAuthRoutes />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                </Route>

            </Route>
        </Routes>
    )
}

export default WebRoutes;